import axios from 'axios';

import {
  setFlashcardOnlyAction,
  setSwitchPfeSktValue,
} from '../actions/accountSettingsAction';
import { getBannersActiveAction } from '../actions/bannerAction';
import { getNotificationsMessages } from '../actions/notificationMessageAction';
import {
  setlastNotificationsRequest,
  setLoading,
  setUser,
} from '../actions/userActions';
import { getlastNotificationsRequest } from '../components/User/userSelectors';
import { store } from '../index';
import history from '../utils/history';
import tokenExpiredOrMaintenanceInterceptor from '../utils/tokenExpiredOrMaintenanceInterceptor';

const BASE_URL = process.env.REACT_APP_BASE_URL;
tokenExpiredOrMaintenanceInterceptor();

export function isLoggedUser() {
  return axios.get(`${BASE_URL}/isLoggedUser`).then(({ data }) => data);
}

export function login(email, password, rememberMe) {
  return axios
    .post(`${BASE_URL}/login`, {
      email,
      password,
      rememberMe,
    })
    .then(({ data }) => data);
}

export function logout() {
  return axios.post(`${BASE_URL}/logout`).then(({ data }) => data);
}

export function requestPassword(email) {
  return axios
    .patch(`${BASE_URL}/requestResetPassword/`, {
      email,
    })
    .then(({ data }) => data);
}

export function resetPasswordService(password, confirmPassword, token) {
  return axios
    .patch(`${BASE_URL}/resetPassword/`, {
      password,
      confirmPassword,
      token,
    })
    .then(({ data }) => data);
}

export function getLoggedStudent() {
  return axios.get(`${BASE_URL}/me`).then(({ data, status }) => {
    if (status === 503) {
      // server is in maintenance
      return { isMaintenance: true };
    }

    if (data && data.isBlocked) {
      store.dispatch(setUser({}));
      store.dispatch(setLoading(false));
      logout().then(() => {
        history.push('/login');
      });
      return;
    }
    if (
      window.location.href &&
      window.location.href.includes('token') &&
      !window.location.href.includes('unsubscribe')
    ) {
      history.push('/dashboard');
    }
    store.dispatch(setLoading(false));
    store.dispatch(setUser(data));
    store.dispatch(setFlashcardOnlyAction(data.userSetting.flashcardOnly));
    store.dispatch(setSwitchPfeSktValue(data.userSetting.currentRateId));
    const lastNotificationRequested = getlastNotificationsRequest(
      store.getState(),
    );
    const now = Date.now();
    const delay = 1800000;
    if (
      lastNotificationRequested === 0 ||
      lastNotificationRequested + delay < now
    ) {
      store.dispatch(getBannersActiveAction());
      store.dispatch(getNotificationsMessages(data.id));
      store.dispatch(setlastNotificationsRequest(now));
    }

    if (data.isForceUpdatePassword && data.resetPasswordToken) {
      history.push(`/password-reset/${data.resetPasswordToken}`);
    }
    return data;
  });
}

export function getDoubleSubscription(user) {
  return axios
    .post(`${BASE_URL}/getDoubleSubscription`, { user })
    .then(({ data }) => data);
}

export function getUserProgressOnChapters(studyId, studyMethod) {
  return axios
    .get(`${BASE_URL}/getUserProgressOnChapters`, {
      params: { studyId, studyMethod },
    })
    .then(({ data }) => data);
}

export async function updateQualForDailyQuiz(qualDailyQuiz) {
  return axios
    .put(`${BASE_URL}/updateQualDailyQuiz`, { qualDailyQuiz })
    .then(({ data }) => data);
}
